<template>
  <div id="listWidget" class="mb-4" style="padding-bottom: 2rem;">
    
    <div>
      <!-- <h4 class="mb-3">영역설정</h4> -->
      
      <!-- 영역 설정 단계 안내 -->
      <div class="instruction-card card-item mb-3">
        <div class="instruction-header">
          <i class="fa-solid fa-list-ol me-2 text-primary"></i>
          <span class="instruction-title">영역 설정 단계</span>
        </div>
        <div class="instruction-body">
          <div class="instruction-step">
            <div class="step-number">1</div>
            <div class="step-content">
              <span>영역을 추가해주세요. 아래 <strong class="text-primary">영역 버튼</strong>을 누르시면 해당 영역이 추가 됩니다.</span>
            </div>
          </div>
          <div class="instruction-step">
            <div class="step-number">2</div>
            <div class="step-content">
              <span>추가된 영역의 <strong class="text-primary">방 관리</strong>를 누르시면 방 관리 화면으로 이동할 수 있습니다.</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 영역 선택 카드 -->
      <div class="zone-select-card card-item mb-3">
        <div class="zone-select-card-header">
          <i class="fa-regular fa-house me-2 text-primary"></i>
          <span class="zone-select-card-title">영역 추가</span>
        </div>
        <div class="zone-select-card-body">
          <button
            type="button"
            class="btn btn-outline-primary"
            style="min-width: 80px"
            v-for="(item, index) in templateZoneNames"
            :key="index"
            @click="onAddZoneClick(item)"
          >
            {{ item }}
          </button>
        </div>
      </div>
    </div>

    <!-- <hr class="mb-4" v-if="zones?.length > 0" /> -->

    <div class="row">
      <ZoneItem
        v-for="(item, index) in zones"
        :key="item._id"
        :index="index"
        :data="item"
        @onDeleteClick="onDeleteZoneClick"
        @onZoneUpdated="onZoneUpdated"
      />
    </div>

    <PopDialog
      title="영역추가"
      :visible="addZoneModal.visible"
      :okCallback="onAddZoneConfirmClick"
      :cancelCallback="addZoneModal.hide"
    >
      <input
        type="text"
        class="form-control form-control-lg fs-15px"
        placeholder="영역 이름을 입력해주세요."
        v-model="addZoneName"
      />
    </PopDialog>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  getCurrentInstance,
  onBeforeMount,
  computed,
  onMounted,
  onBeforeUnmount,
  watch,
  onUnmounted,
} from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Axios, { ZoneApi } from '@/api';
import PopDialog from '@/common/components/popup/PopDialog.vue';
import useModal from '@/common/hooks/useModal';
import ZoneItem from './components/ZoneItem.vue';
import { Template } from '@/common/constants';
import Card from '@/common/template/components/bootstrap/Card.vue';
import CardBody from '@/common/template/components/bootstrap/CardBody.vue';

const { emitter, mobile, logger } =
  getCurrentInstance().appContext.config.globalProperties;
let zones = ref([]);
let templateZoneNames = ref(Template.ZoneNames);
const store = useStore();
const router = useRouter();
const addZoneModal = reactive(useModal());
let addZoneName = ref('');

watch(zones, () => {
  console.log('HomeSettingPage.watch => zones : ', zones.value);
});

onBeforeMount(() => {
  console.log('HomeSettingPage.onMounted => onBeforeMount : ',{title:'네트워크 설정',isShowZone:false})
  emitter.emit('onChangeHeaderSetting',{title:'영역 설정',isShowMenu:false,isShowZone:false,isShowProfile:false,isShowRightHome:true});  
});
onBeforeUnmount(() =>{
  console.log('HomeSettingPage.onBeforeUnmount => onChangeHeaderSetting : ',{title:'네트워크 설정',isShowZone:false})
  emitter.emit('onChangeHeaderSetting',{title:'',isShowMenu:true,isShowZone:true,isShowProfile:true,isShowRightHome:false});
})
onMounted(async () => {
  requestZones();
  
});

const hasNotConfiguration = computed(() => {
  return zones.value.some((zone) => zone.controllers.length === 0);
});

const onAddZoneClick = async (name) => {
  if (zones.value && zones.value.length > 0 && hasNotConfiguration.value) {
    emitter.emit('showPopAlert', {
      description:
        '완료되지 않은 영역이 있습니다.\n미완료된 영역 설정을 완료 후 새 영역을 추가할 수 있습니다.',
    });
    return;
  }

  if (name === Template.ZoneNames[Template.ZoneNames.length - 1]) {
    addZoneModal.show();
    return;
  }

  let result = await requestAddZone(name);
  console.log(result)
  if (result && result.zone) {
    await requestZones();
    setTimeout(() => {
      emitter.emit('showPopAlert', {
        description: `[${result.zone.name}]영역이 추가되었습니다.\n조명제어기나 온도조절기를 등록해주세요.`,
      });
    }, 300);
  }
};

const onAddDeviceClick = () => {
  console.log('add device click');
};

const onDeleteZoneClick = (payload) => {
  console.log('HomeSettingPage.onDeleteZoneClick => payload :', payload);

  let groups = zones.value.find((z) => z._id == payload.zoneId).groups;
  if (groups.length > 0) {
    emitter.emit('showPopConfirm', {
      description: '방정보가 포함된 영역입니다.\n정말 삭제하시겠습니까?',
      okCallback: async () => {
        try {
          await requestDeleteZone(payload.zoneId);
          emitter.emit('showPopAlert', {
            description: '영역이 삭제되었습니다.',
          });
        } catch (e) {
          emitter.emit('showPopAlert', {
            description: e,
          });
        }
      },
      cancelCallback: () => {},
    });
    return;
  }
  requestDeleteZone(payload.zoneId);
};

const onZoneUpdated = () => {
  requestZones();
};

const onAddZoneConfirmClick = async () => {
  console.log(addZoneName.value);
  if (addZoneName.value.length === 0) {
    emitter.emit('showPopAlert', {
      description: "영역 이름을 입력해주세요.",
    });
    return;
  }

  addZoneModal.hide();
  let result = await requestAddZone(addZoneName.value);
  console.log(result)
  if (result && result.zone) {
    await requestZones();
    setTimeout(() => {
      emitter.emit('showPopAlert', {
        description: `[${result.zone.name}]영역이 추가되었습니다.\n조명제어기나 온도조절기를 등록해주세요.`,
      });
    }, 300);
  }
};

const requestZones = async () => {
  try {
    const result = await Axios.get(ZoneApi.ZONES, { isOwner: true });
    console.log('HomeSettingPage.requestZones => result : ', result);
    if (result.resultCode === '0000') {
      zones.value = result.resultData;
      return;
    }
    if (result.resultMessage) {
      emitter.emit('showPopAlert', {
        description: result.resultMessage,
      });
    }
    return false;
  } catch (error) {
    emitter.emit('showPopAlert', {
      description: '기존 영역 조회에 실패했습니다.',
    });
    return false;
  }
};
const requestAddZone = async (name) => {
  try {
    const result = await Axios.post(ZoneApi.REGIST_ZONE, { name: name });
    if (result.resultCode === '0000') {
      store.commit('home/addZone', {
        ...result.resultData,
        isOwner: true,
      });
      return { zone: result.resultData, result: true };
    }

    emitter.emit('showPopAlert', {
      description: result.resultMessage,
    });
    return { result: false, zone: undefined };
  } catch (e) {
    console.log(e);
    emitter.emit('showPopAlert', {
      description: '영역 추가중 오류가 발생하였습니다.',
    });
  }
};
const requestDeleteZone = async (zoneId) => {
  try {
    const result = await Axios.delete(
      ZoneApi.DELETE_ZONE.replace(':id', zoneId),
    );
    if (result.resultCode === '0000') {
      requestZones();
      store.commit('home/deleteZone', zoneId);
      return;
    }

    emitter.emit('showPopAlert', {
      description: result.resultMessage,
    });
  } catch (error) {
    emitter.emit('showPopAlert', {
      description: '기존 영역 조회에 실패했습니다.',
    });
  }
};
</script>

<style scoped>
/* instruction-card 스타일 */
.instruction-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.instruction-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.instruction-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.instruction-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #212529;
}

.instruction-body {
  padding: 0.75rem 1rem;
}

.instruction-step {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.instruction-step:last-child {
  margin-bottom: 0;
}

.step-number {
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0d6efd;
  color: white;
  border-radius: 50%;
  font-weight: 600;
  font-size: 0.75rem;
}

.step-content {
  flex: 1;
  padding-top: 0.1rem;
  font-size: 0.85rem;
  line-height: 1.6;
  color: #495057;
}

.step-content strong {
  color: #0d6efd;
  font-weight: 600;
}

/* zone-select-card 스타일 */
.zone-select-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.zone-select-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.zone-select-card-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.zone-select-card-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #212529;
}

.zone-select-card-body {
  padding: 1rem;
  display: flex;
  flex-wrap: nowrap;
  gap: 0.5rem;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.zone-select-card-body .btn {
  font-size: 0.875rem;
  padding: 0.5rem 1rem;
  transition: all 0.2s ease;
  flex-shrink: 0;
  margin-bottom: 0;
  margin-right: 0;
}

.zone-select-card-body .btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 모바일 반응형 간격 조정 */
@media (max-width: 768px) {
  #listWidget {
    margin-bottom: 1rem;
    padding-bottom: 2rem;
  }

  .instruction-card,
  .zone-select-card {
    margin-bottom: 1rem;
  }

  .zone-select-card-body .btn {
    font-size: 0.8rem;
    padding: 0.4rem 0.75rem;
    min-width: 60px;
  }
}
</style>
